// reducer.js
import {
  GET_SOLUTIONS,
  GET_SOLUTIONS_SUCCESS,
  GET_SOLUTIONS_FAIL,
  ADD_SOLUTION,
  ADD_SOLUTION_SUCCESS,
  ADD_SOLUTION_FAIL,
  UPDATE_SOLUTION,
  UPDATE_SOLUTION_SUCCESS,
  UPDATE_SOLUTION_FAIL,
  DELETE_SOLUTION,
  DELETE_SOLUTION_SUCCESS,
  DELETE_SOLUTION_FAIL,
} from './actionTypes';

const initialState = {
  solutions: [],
  loading: false,
  error: null,
  status: null,
  fieldErrors: {},
};

const solutionReducer = (state = initialState, action) => {
  switch (action.type) {
    // ---------------- GET ----------------
    case GET_SOLUTIONS:
      return { ...state, loading: true };
    case GET_SOLUTIONS_SUCCESS:
      return { ...state, loading: false, solutions: action.payload };
    case GET_SOLUTIONS_FAIL:
      return { ...state, loading: false, error: action.payload };

    // ---------------- ADD ----------------
    case ADD_SOLUTION:
      return { ...state, loading: true };
    case ADD_SOLUTION_SUCCESS:
      return { ...state, loading: false, status: 'success', fieldErrors: {} };
    case ADD_SOLUTION_FAIL:
      return { ...state, loading: false, error: action.payload };

    // ---------------- UPDATE ----------------
    case UPDATE_SOLUTION:
      return { ...state, loading: true };
    case UPDATE_SOLUTION_SUCCESS:
      return { ...state, loading: false, fieldErrors: {} };
    case UPDATE_SOLUTION_FAIL:
      return { ...state, loading: false, error: action.payload };

    // ---------------- DELETE ----------------
    case DELETE_SOLUTION:
      return { ...state, loading: true };
    case DELETE_SOLUTION_SUCCESS:
      return { ...state, loading: false };
    case DELETE_SOLUTION_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default solutionReducer;
